import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { QuoteResponse } from '@us-registration/util-models';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RegistrationFacade } from '../../+state/registration.facade';

export const hasQuoteGuard: CanActivateFn = (route): Observable<boolean> => {
  const registrationFacade = inject(RegistrationFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasQuoteGuard', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  return registrationFacade.quoteResponse$.pipe(
    first(),
    map((hasQuoteResponse: QuoteResponse | undefined) => {
      if (!hasQuoteResponse) {
        router.navigate([redirectTo], {
          queryParams: route.queryParams,
          replaceUrl: true,
        });
        return false;
      }
      loggingService.debug('hasQuoteGuard', 'Success');
      return true;
    })
  );
};
